import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a29ab23"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-payment-method-component" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "payment-method-items" }
const _hoisted_4 = { class: "payment-method-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-f icon-CreditCard icon-blue fs-34" }, null, -1))
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "payment-method-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-f icon-Cash icon-blue fs-34" }, null, -1))
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "payment-method-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-f icon-Check icon-blue fs-34" }, null, -1))
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "payment-method-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-f icon-blue icon-BankTransfer fs-34" }, null, -1))
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "footer-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BackAndCancelFooter = _resolveComponent("BackAndCancelFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("cashier.header.select-payment-method")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, { to: { name: 'creditCard' } }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("cashier.label.creditcard")), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'cash' } }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("cashier.label.cash")), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'check' } }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("cashier.label.check")), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'bankTransfer' } }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("cashier.label.banktransfer")), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = () => _ctx.openCashDrawerPrinter())
        }, _toDisplayString(_ctx.$t("cashier.label.open-money-drawer")), 1)
      ])
    ]),
    _createVNode(_component_BackAndCancelFooter, {
      firstBtnText: _ctx.$t('cashier.label.back-to-products')
    }, null, 8, ["firstBtnText"])
  ]))
}